import { useNavigate } from "react-router-dom";
import { useQuoteForm } from "../../hooks/useQuoteForm";

export default function QuoteForm() {
  const navigate = useNavigate();

  const {
    clienteNombre, setClienteNombre,
    clienteTelefono, setClienteTelefono,
    clienteDireccion, setClienteDireccion,
    clienteEmail, setClienteEmail,
    fechaVigencia, setFechaVigencia,
    notas, setNotas,
    descuento, setDescuento,
    items,
    searchTerm,
    searchResults,
    searching,
    saving,
    subtotal,
    total,
    buscarProductos,
    agregarProducto,
    agregarProductoManual,
    actualizarItem,
    eliminarItem,
    handleSubmit,
  } = useQuoteForm((quote) => {
    // Al crear con éxito, regresamos al listado
    navigate("/quotes");
  });

  return (
    <div className="invoice-list-container">
      <div className="card">
        {/* Header */}
        <div className="card-header">
          <h2 className="card-title">➕ Nueva Cotización</h2>
          <button className="btn btn-secondary" onClick={() => navigate("/quotes")}>
            ← Volver al listado
          </button>
        </div>

        <div className="card-body">
          {/* ============== DATOS DEL CLIENTE (opcionales) ============== */}
          <h4 style={{ marginBottom: "12px" }}>Datos del cliente (opcional)</h4>
          <div className="filters-row" style={{ flexWrap: "wrap", gap: "12px" }}>
            <div className="form-group" style={{ flex: "1 1 220px" }}>
              <label className="form-label">Nombre del cliente</label>
              <input
                type="text"
                className="form-control"
                placeholder="Ej: Ferretería El Martillo"
                value={clienteNombre}
                onChange={(e) => setClienteNombre(e.target.value)}
              />
            </div>

            <div className="form-group" style={{ flex: "1 1 180px" }}>
              <label className="form-label">Teléfono</label>
              <input
                type="text"
                className="form-control"
                placeholder="Opcional"
                value={clienteTelefono}
                onChange={(e) => setClienteTelefono(e.target.value)}
              />
            </div>

            <div className="form-group" style={{ flex: "1 1 220px" }}>
              <label className="form-label">Correo</label>
              <input
                type="email"
                className="form-control"
                placeholder="Opcional"
                value={clienteEmail}
                onChange={(e) => setClienteEmail(e.target.value)}
              />
            </div>

            <div className="form-group" style={{ flex: "1 1 180px" }}>
              <label className="form-label">Vigencia hasta</label>
              <input
                type="date"
                className="form-control"
                value={fechaVigencia}
                onChange={(e) => setFechaVigencia(e.target.value)}
              />
            </div>
          </div>

          <div className="form-group" style={{ marginTop: "12px" }}>
            <label className="form-label">Dirección</label>
            <input
              type="text"
              className="form-control"
              placeholder="Opcional"
              value={clienteDireccion}
              onChange={(e) => setClienteDireccion(e.target.value)}
            />
          </div>

          <hr style={{ margin: "20px 0" }} />

          {/* ============== BUSCADOR DE PRODUCTOS ============== */}
          <h4 style={{ marginBottom: "12px" }}>Agregar productos</h4>
          <div className="form-group" style={{ position: "relative" }}>
            <label className="form-label">🔎 Buscar producto por nombre o código</label>
            <input
              type="text"
              className="form-control"
              placeholder="Escribe para buscar en el inventario..."
              value={searchTerm}
              onChange={(e) => buscarProductos(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && searchResults.length === 0 && searchTerm.trim()) {
                  agregarProductoManual(searchTerm.trim());
                }
              }}
            />

            {searching && (
              <div style={{ padding: "8px", color: "#718096", fontSize: "13px" }}>
                Buscando...
              </div>
            )}

            {!searching && searchTerm.trim() && searchResults.length > 0 && (
              <div
                className="table-container"
                style={{
                  position: "absolute",
                  zIndex: 10,
                  width: "100%",
                  maxHeight: "260px",
                  overflowY: "auto",
                  background: "#fff",
                  border: "1px solid #e2e8f0",
                  borderRadius: "8px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                }}
              >
                {searchResults.map((producto) => (
                  <div
                    key={producto.id}
                    onClick={() => agregarProducto(producto)}
                    style={{
                      padding: "10px 12px",
                      cursor: "pointer",
                      borderBottom: "1px solid #f0f0f0",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.background = "#f7fafc")}
                    onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}
                  >
                    <span>
                      <strong>{producto.nombre}</strong>{" "}
                      {producto.codigo && (
                        <span style={{ color: "#a0aec0" }}>({producto.codigo})</span>
                      )}
                    </span>
                    <span>$ {Number(producto.precio_venta).toFixed(2)}</span>
                  </div>
                ))}
              </div>
            )}

            {!searching &&
              searchTerm.trim() &&
              searchResults.length === 0 && (
                <div
                  style={{
                    marginTop: "6px",
                    fontSize: "13px",
                    color: "#718096",
                  }}
                >
                  Sin resultados en inventario. Presiona{" "}
                  <strong>Enter</strong> para agregar "{searchTerm}" como ítem libre.
                </div>
              )}
          </div>

          {/* ============== TABLA DE ITEMS ============== */}
          <div className="table-container" style={{ marginTop: "16px" }}>
            <table className="table">
              <thead>
                <tr>
                  <th>PRODUCTO</th>
                  <th style={{ width: "110px" }}>CANTIDAD</th>
                  <th style={{ width: "140px" }}>PRECIO UNIT.</th>
                  <th style={{ width: "120px" }}>SUBTOTAL</th>
                  <th style={{ width: "60px" }}></th>
                </tr>
              </thead>
              <tbody>
                {items.length === 0 ? (
                  <tr>
                    <td colSpan={5} className="text-center">
                      <div className="no-data">
                        <p>📭 Aún no has agregado productos</p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  items.map((item, index) => (
                    <tr key={index}>
                      <td>{item.nombre_producto}</td>
                      <td>
                        <input
                          type="number"
                          min="1"
                          className="form-control"
                          value={item.cantidad}
                          onChange={(e) =>
                            actualizarItem(index, "cantidad", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          min="0"
                          step="0.01"
                          className="form-control"
                          value={item.precio_unitario}
                          onChange={(e) =>
                            actualizarItem(index, "precio_unitario", e.target.value)
                          }
                        />
                      </td>
                      <td style={{ textAlign: "right" }}>
                        $ {(Number(item.cantidad) * Number(item.precio_unitario)).toFixed(2)}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => eliminarItem(index)}
                          title="Quitar"
                        >
                          🗑️
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* ============== DESCUENTO Y TOTALES ============== */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "16px",
            }}
          >
            <div style={{ width: "320px" }}>
              <div className="form-group" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <label className="form-label" style={{ flex: 1 }}>Descuento ($)</label>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  className="form-control"
                  style={{ width: "140px", textAlign: "right" }}
                  value={descuento}
                  onChange={(e) => setDescuento(e.target.value)}
                />
              </div>

              <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}>
                <span>Subtotal</span>
                <span>$ {subtotal.toFixed(2)}</span>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px 0",
                  fontWeight: "bold",
                  fontSize: "16px",
                  borderTop: "1px solid #e2e8f0",
                }}
              >
                <span>TOTAL</span>
                <span>$ {total.toFixed(2)}</span>
              </div>
            </div>
          </div>

          {/* ============== NOTAS ============== */}
          <div className="form-group" style={{ marginTop: "12px" }}>
            <label className="form-label">Notas / Condiciones (opcional)</label>
            <textarea
              className="form-control"
              rows={3}
              placeholder="Ej: Precios sujetos a cambio sin previo aviso. Vigencia 8 días."
              value={notas}
              onChange={(e) => setNotas(e.target.value)}
            />
          </div>

          {/* ============== ACCIONES ============== */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "12px",
              marginTop: "20px",
            }}
          >
            <button
              className="btn btn-secondary"
              onClick={() => navigate("/quotes")}
              disabled={saving}
            >
              Cancelar
            </button>
            <button
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={saving}
            >
              {saving ? "Generando..." : "📄 Generar Cotización"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}